<template>
  <div class="min-h-[8rem]">
    <Link
      class="hover:underline"
      :href="route('trips.create', { departure_date: props.day })"
    >
      <BadgeBase class="m-1">{{ date.date() }}</BadgeBase></Link
    >
    <CalendarEvent v-for="event in props.events" :event="event" />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { Link } from '@inertiajs/inertia-vue3'
import dayjs from 'dayjs'
import BadgeBase from '@/Common/Elements/Badges/BadgeBase.vue'
import CalendarEvent from './CalendarEvent.vue'

const props = defineProps({
  day: String,
  events: Array,
})

const date = computed(() => new dayjs(props.day))
</script>
